import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private themeSubject = new BehaviorSubject<'light' | 'dark'>('light')
  theme$ = this.themeSubject.asObservable()

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  setTheme(theme: string) {
    const validTheme = theme.includes('light') ? 'light' : theme.includes('dark') ? 'dark' : null

    if (!validTheme) {
      console.warn(`Tema no válido: ${theme}`)
      return
    }

    if (isPlatformBrowser(this.platformId)) {
      const themeLink = document.getElementById('theme-css') as HTMLLinkElement
      if (themeLink) {
        themeLink.href = `/assets/themes/aura-${validTheme}-indigo/theme.css`
      }

      document.documentElement.setAttribute('data-theme', validTheme)
    }

    this.themeSubject.next(validTheme as 'light' | 'dark')
  }

  getTheme(): 'light' | 'dark' {
    return this.themeSubject.value
  }
}
